import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardComponent {
  @Input() firstName: string = '';
  @Input() lastName: string = '';
  @Input() email: string = '';

  @Input() canOnboard: boolean = false;
  @Input() canSelect: boolean = false;
  @Input() canFind: boolean = false;
  @Input() canTest: boolean = false;

  @Input() onboardUrl: string = '';
  @Input() selectUrl: string = '';
  @Input() findUrl: string = '';
  @Input() testUrl: string = '';

  @Output() logout = new EventEmitter<void>();

  onActionLinkClick(event: MouseEvent, isEnabled: boolean, url: string): void {
    if (!isEnabled) {
      event.preventDefault();
      event.stopPropagation();
    } else {

      window.open(url, '_blank');
      event.preventDefault();
    }
  }

  onLogoutClick() {
    this.logout.emit();
  }
}
